import { render, staticRenderFns } from "./GlobalStyles.vue?vue&type=template&id=1c4dd3d2&scoped=true&"
import script from "./GlobalStyles.vue?vue&type=script&lang=js&"
export * from "./GlobalStyles.vue?vue&type=script&lang=js&"
import style0 from "./GlobalStyles.vue?vue&type=style&index=0&id=1c4dd3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dd3d2",
  null
  
)

export default component.exports